import { render, staticRenderFns } from "./NewAppeal.vue?vue&type=template&id=23d81477&"
import script from "./NewAppeal.vue?vue&type=script&lang=js&"
export * from "./NewAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports